import type { RouteRecordRaw } from 'vue-router';

export const SIGN_ROUTER: RouteRecordRaw = {
  path: '/sign',
  component: () => import('@/modules/sign/components/SignLayout.vue'),
  meta: { requiresAuth: false },
  children: [
    {
      path: '',
      component: () => import('@/modules/sign/views/Login.vue'),
      name: 'Login',
      meta: {
        title: '로그인',
      },
    },
  ],
};
